import { cn } from '@/lib/utils'

export default function CloseIcon({ ...props }) {
  return (
    <svg
      width='20'
      height='21'
      viewBox='0 0 20 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={cn('cursor-pointer text-[#4E545E] transition-all duration-200 ease-in-out', props.className)}
      {...props}
    >
      <path
        d='M15.8333 6.13166L14.6583 4.95667L9.99999 9.615L5.34166 4.95667L4.16666 6.13166L8.82499 10.79L4.16666 15.4483L5.34166 16.6233L9.99999 11.965L14.6583 16.6233L15.8333 15.4483L11.175 10.79L15.8333 6.13166Z'
        fill='currentColor'
      />
    </svg>
  )
}
